import React, { useState } from 'react'
import AgronomyDetailForm from './AgronomyDetailForm';
import AgronomyDetailList from './AgronomyDetailList';

const AgronomyDetail= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <AgronomyDetailForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <AgronomyDetailList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default AgronomyDetail;